import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select } from "antd";
import { getData } from "country-list";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
const AddressForm = (props) => {
  const [number, setNumber] = useState(props.phoneNumberPrefixes[0]);
  const [form] = Form.useForm();
  const [phoneNumberPrefix, setPhoneNumberPrefix] = useState([]);

  const countryChangeHandler = (value) => {
    props.onCountryChange(value);
  };

  useEffect(() => {
    if (props.phoneNumberPrefixes) setNumber(props.phoneNumberPrefixes?.[0]);
  }, [props.phoneNumberPrefixes]);

  const onFinish = (values) => {
    props.onFinish(values);
  };

  const prefixSelector = (numberParam) => (
    <Form.Item name="prefix" noStyle key={numberParam}>
      <Select
        style={{
          width: 90,
        }}
        value={numberParam}
        defaultValue={numberParam}
      >
        {/* {props.phoneNumberPrefixes.map((item) => ( */}
        <Option value={numberParam}>{numberParam}</Option>
        {/* ))} */}
      </Select>
    </Form.Item>
  );

  const acceptNumber = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      return true;
    } else {
      return false;
    }
  };

  const onPhoneTextChange = (e) => {
    debugger;
    if (!acceptNumber(e)) {
      e.preventDefault();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <h2>Add Address</h2>
      <Form
        {...formItemLayout}
        form={form}
        name="register"
        onFinish={onFinish}
        initialValues={{
          prefix: number,
        }}
        onFinishFailed={onFinishFailed}
        autoComplete="off"

        // scrollToFirstError
      >
        <Form.Item
          name="country"
          label="Country"
          rules={[
            {
              required: true,
              message: "Please enter your country name!",
            },
          ]}
        >
          <Select
            required
            style={{
              width: "200px",
            }}
            showSearch
            placeholder="Select Country"
            optionFilterProp="children"
            allowClear
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            onChange={countryChangeHandler}
            options={props.countries.map((el) => {
              return {
                label: el,
                value: el,
              };
            })}
          />
        </Form.Item>
        <Form.Item
          name="zipcode"
          label="zip code"
          rules={[
            {
              required: true,
              message: "Please enter your zip code!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            style={{
              width: "100px",
            }}
          />
        </Form.Item>
        <Form.Item
          name="city"
          label="City"
          rules={[
            {
              required: true,
              message: "Please enter your city!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            style={{
              width: "100px",
            }}
          />
        </Form.Item>
        <Form.Item
          name="state"
          label="State / Province"
          rules={[
            {
              required: true,
              message: "Please enter your state!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            style={{
              width: "100px",
            }}
          />
        </Form.Item>

        <Form.Item
          name="addressOne"
          label="Address line 1 *"
          rules={[
            {
              required: true,
              message: "Please enter your address one!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input.TextArea maxLength={30} />
        </Form.Item>
        <Form.Item
          name="addressTwo"
          label="Address line 2"
          rules={[
            {
              // required: true,
              message: "Please enter your address two!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input.TextArea maxLength={30} />
        </Form.Item>

        <Form.Item
          name="contactPerson"
          label="Contact Person"
          rules={[
            {
              required: true,
              message: "Please enter contact person!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input required />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[
            {
              required: true,
              message: "Please enter your phone number !",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            maxLength={10}
            addonBefore={prefixSelector(number)}
            style={{
              width: "100%",
            }}
            required
          />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter your email!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input required />
        </Form.Item>
        <Form.Item
          name="designation"
          label="Designation"
          rules={[
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="saveAddress"
          label="Save Address As"
          rules={[
            {
              required: true,
              message: "Please enter your save address!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input
            style={{
              width: "180px",
            }}
          />
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            ok
          </Button>
          <Button
            type="default"
            onClick={() => {
              props.setmodalContent("");
            }}
            style={{
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddressForm;
